import React from 'react';
import CowDetail from '../components/CowDetail';

const CowDetailPage = () => {
  return (
    <div>
      <CowDetail />
    </div>
  );
};

export default CowDetailPage;
